module.exports = __webpack_public_path__ + "static/media/ad-amazon.c9fce6a0.png";